import { useContext, useEffect, useRef } from "react";
import useCredencialesNotificadores from "../../../api/credencialesNotificadores";
import { ContainerScreenGeneral, MuniSpinner2, Table } from "../../../components";
import { UserContext } from "../../../context";
import { useCredencialesNotificadoresStore } from "../../../store/credencialesNotificadoresStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalCargarNotificador from "../../../views/modals/ModalCargarNotificador";
import ModalCredencialNotificador from "../../../views/modals/ModalCredencialNotificador";
import { credencialesNotificadoresTableData } from "./tableData";
import Table2 from "../../../components/Table2";

const CredencialesNotificadores = () => {
  const intervalIdRef = useRef(null);
  const { actions } = useContext(UserContext);

  const { modals, loads, handlerModal } = useGeneralAppStore();
  const { credencialesNotificadores } = useCredencialesNotificadoresStore();
  const { getCredencialesNotificadores, getCredencialNotificador } = useCredencialesNotificadores();

  useEffect(() => {
    getCredencialesNotificadores();
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  return (
    <ContainerScreenGeneral size={"md"} linkBack={"/"} titulo={"Credenciales Notificadores"}>
      <div className="bg-white w-100" style={{ height: "100vh" }}>
        <div className="d-flex justify-content-end">
          <div className="d-flex gap-2 mb-2">
            <button
              className="btn btn-primary"
              onClick={() => handlerModal({ modal: true, modalName: "cargar_notificador" })}
            >
              Cargar Notificador
            </button>
          </div>
        </div>

        <section className="position-relative">
          {/* spinners de carga */}
          {loads.includes("credenciales-notificadores") && (
            <div
              className="d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}
          {loads.includes("credencial-notificador") && (
            <div
              className="d-flex justify-content-center align-items-center position-absolute w-100 h-100 z-3"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}

          <div className="mt-2" style={{height:"600px"}}>
            <Table2
            height={"100%"}
              search
              loading={loads.includes("credenciales-notificadores")}
              data={credencialesNotificadoresTableData(
                credencialesNotificadores,
                getCredencialNotificador
              )}
            />
          </div>
        </section>
      </div>

      {modals.includes("credencial_notificador") && <ModalCredencialNotificador />}
      {modals.includes("cargar_notificador") && <ModalCargarNotificador />}
    </ContainerScreenGeneral>
  );
};

export default CredencialesNotificadores;
